<template>
  <div class="wrapper" style="height:400px;width:100%;">
    <div class="row">
      <div class="col-md">
        <div role="toolbar" class="btn-toolbar justify-content-between mb-2">
          <button @click="save()" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
          <div class="input-group ml-3">
            <input type="text" placeholder="Auftrags-Nr" class="form-control" v-model="testid"/>
            <div class="input-group-append">
              <button @click="testRule" class="btn btn-secondary"><font-awesome-icon icon="vial"/></button>
            </div>
          </div>
        </div>
        <AceEditor ref="editor" :editorId='"pricecalceditor"' :lang="'javascript'" :content="script"/>
      </div>
      <div class="col-md">
        <iframe style="width:100%;height:500px;border: none;" :src="baseurl + 'help/scriptrules/price_calculation.html'">
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
import rules from '@/modules/rules.js'
import config from '@/modules/config.js'
import AceEditor from '@/components/AceEditor.vue'

export default {
  name: 'RulePriceCalc',
  components: {
    AceEditor
  },
  data() {
    return {
      baseurl: config.baseUrl,
      script: "",
      testid: '',
    }
  },
  created: function() {
    var self = this;
    config.get(this,config.baseUrl + 'rest/config/base?set=%5B%22if.proxy.pricecalc%22%5D','Preis-Skript laden',function(data) {
      if (data) {
        self.script = data['if.proxy.pricecalc'];
      }
    });
  },
  methods: {
    testRule: function() {
      console.log('test');
      if (this.testid == '')  {
        this.$bvToast.toast('Bitte zuerst eine Auftragsnummer als Beispiel eingeben.',{title:'Preisberechnung',variant:'warning'})
        return;
      }
      var self = this;
      rules.testpricecalc(this,this.testid,function(data){
        self.$bvToast.toast('Prüfung: ' + data.report,{title:'Preisberechnung',variant:data.status})
      })
    },
    save: function() {
      this.script = this.$refs.editor.getContent();
      var data = {};
      data['if.proxy.pricecalc'] = this.script;

      var self = this;
      config.savecfg(data,this,function() {
        console.log('done');
        self.$bvToast.toast('Preisregel gespeichert',{title: 'Gespeichert', variant: "success"});
      })
    }
  }
}
</script>
